import React, { Component } from 'react';

class EdbButton extends Component {
    
    render() {
        return (<button className={"edb-button edb-round " + this.props.className} disabled={this.props.loading || this.props.disabled} onClick={this.props.onClick}>
            {!this.props.loading && this.props.content}
            {this.props.loading && <span>
                {this.props.loadingIndicator || <i className="edb-large fas fa-spinner edb-spin"></i>}
                &nbsp;
                {this.props.loadingContent || "Carregando..."}
            </span>}
        </button>);
    }
}

export default EdbButton;
